module.exports = __webpack_public_path__ + "img/chair_163.d59722fe.jpg";